import { Box, Typography } from '@mui/material';
import { Addendum } from '@uplift/api';
import { DateFormats } from '@uplift/constants';
import { useTimezone } from '@uplift/contexts';
import { useUserDisplayNameQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';
import React from 'react';

export type AddendumContentProps = {
  addendum: Addendum;
  providerId: string;
};

export const AddendumContent: React.VFC<AddendumContentProps> = ({ addendum, providerId }) => {
  const timezone = useTimezone();
  const createdAt = React.useMemo(() => {
    return CalendarDateService.date(addendum.createdAt).tz(timezone);
  }, [ addendum.createdAt, timezone ]);
  const { data: providerDisplayName } = useUserDisplayNameQuery(providerId, { suspense: true });

  return (
    <Box mx={3} bgcolor="grey.50">
      <Box px={3} py={3} display="flex" flexDirection="column">
        <Typography>{addendum?.content}</Typography>
        <Box pt={4}>
          <Typography variant="body2" color="textPrimary">
            Submitted by {providerDisplayName?.fullLegalName} on {createdAt.format(DateFormats.DEFAULT_DATE)}, {createdAt.format(DateFormats['hh:mm A'])}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
